// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__3fxbJ"};


//////////////////
// WEBPACK FOOTER
// ./routes/Conversations/Header/style.scss
// module id = Ft9W
// module chunks = 0